var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 851.5 851.5",
    style: {
      enableBackground: "new 0 0 851.5 851.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6067F9;}\r\n\t.st1{fill:#F7F7F7;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2_00000014609654253180946460000008647852002116918688_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124,0h603.6c68.5,0,124,55.5,124,124v603.6c0,68.5-55.5,124-124,124H124c-68.5,0-124-55.5-124-124V124 C0,55.5,55.5,0,124,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M623.5,170.3c-37.4,52.2-84.2,88.4-139.5,112.6c-19.2-5.3-38.9-8-58.3-7.8c-19.4-0.2-39.1,2.6-58.3,7.8 c-55.3-24.3-102.1-60.3-139.5-112.6c-11.3,28.4-54.8,126.4-2.6,263.4c0,0-16.7,71.5,14,132.9c0,0,44.4-20.1,79.7,8.2 c36.9,29.9,25.1,58.7,51.1,83.5c22.4,22.9,55.7,22.9,55.7,22.9s33.3,0,55.7-22.8c26-24.7,14.3-53.5,51.1-83.5 c35.2-28.3,79.7-8.2,79.7-8.2c30.6-61.4,14-132.9,14-132.9C678.3,296.7,634.9,198.7,623.5,170.3z M253.1,414.8 c-28.4-58.3-36.2-138.3-18.3-201.5c23.7,60,55.9,86.9,94.2,115.3C312.8,362.3,282.3,394.1,253.1,414.8z M334.8,517.5 c-22.4-9.9-27.1-29.4-27.1-29.4c30.5-19.2,75.4-4.5,76.8,40.9C360.9,514.7,353,525.4,334.8,517.5z M425.7,678.7 c-16,0-29-11.5-29-25.6s13-25.6,29-25.6s29,11.5,29,25.6C454.7,667.3,441.7,678.7,425.7,678.7z M516.7,517.5 c-18.2,8-26-2.8-49.7,11.5c1.5-45.4,46.2-60.1,76.8-40.9C543.8,488,539,507.6,516.7,517.5z M598.3,414.8 c-29.1-20.7-59.7-52.4-76-86.2c38.3-28.4,70.6-55.4,94.2-115.3C634.6,276.5,626.8,356.6,598.3,414.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo33);
export default __webpack_public_path__ + "static/media/logo-33.559873331d6805ecdeb4d1ed23fcee4d.svg";
export { ForwardRef as ReactComponent };